(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('SoopkitchenDialogController', SoopkitchenDialogController);

    SoopkitchenDialogController.$inject = ['title', '$sce', '$uibModalInstance'];

    function SoopkitchenDialogController(title, $sce, $uibModalInstance) {
        var vm = this;
        /**** Properties ****/
        vm.headerTitle = $sce.trustAsHtml(title);
        vm.saveText = "Save";
        vm.cancelText = "Cancel";
        vm.deleteText = "None";
        vm.delete = null;
        vm.waiting = false;
        vm.saveDisabled = false;
        vm.clear = clear;
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
